import { useEffect, useState } from "react";
import Content from "../../../../../layout/Content";
import billingApi from "@serie3/freelancesplaceapi/api/finance/out";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faEye } from "@fortawesome/free-solid-svg-icons";
import PositionRow from "./PositionRow";
import PositionModal from "../../modals/PositionEdit";
import BillingHeaderRight from "./SubComponents/BillHeaderRight";
import BillingHeaderLeft from "./SubComponents/BillHeaderLeft";
import { useParams, useNavigate } from "react-router-dom";
import FinanceHeader from "../../FinanceHeader";
import listHandler from "@serie3/common/Domain/listHandler";
import PositionView from "../../modals/PositionView";
import PositionRowHeader from "./RowHeader";
import BillSummary from "./BillSummary";
import { useFormik } from "formik";
import FinanceForm from "@serie3/freelancesplaceapi/Form/Billing/FinanceForm";
import Finance from "@serie3/freelancesplaceapi/Domain/Billing/Outgoing/Finance";
import PositionDomain from "@serie3/freelancesplaceapi/Domain/Billing/Outgoing/Position";
import IndexButtons from "./SubComponents/IndexButtons";
import BillView from "../../modals/BillView";
import BillOut from "../../BillOut";
import FinanceApi from "@serie3/freelancesplaceapi/api/finance/out";
import FileDropzone from "../../../documents/modals/FileDropzone";
import NewModal from "../../../documents/modals/NewModal";
import DocumentConnectionButtons from "../../../../../layout/Documents/DocumentConnectionButtons";
import ConnectedFiles from "../../../../../layout/Documents/ConnectedFiles";
import FilePreviewModal from "../../../../../layout/Documents/FilePreviewModal";
import DocumentLinker from "../../../../../layout/Documents/DocumentLinker";
import CheckboxFields from "../shared/Form/FormFields/Checkboxes";
import Fields from "../shared/Form/FormFields/Fields";
import SubmitButtons from "../shared/Form/FormFields/Submitbuttons";
import getSettings from "@serie3/common/config/settings";
import PaymentModal from "../../../../../layout/Payment/PaymentModal";

const Section = ({ title, children, style, extended }) => (
  <div style={{
    background: extended ? "#f4f7ff" : "#fff",
    borderRadius: "12px",
    boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
    padding: "20px 24px", marginBottom: "16px",
    border: extended ? "1px solid #dde6ff" : "1px solid transparent",
    ...style,
  }}>
    {title && (
      <div style={{
        fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase",
        letterSpacing: "0.08em", color: extended ? "#6b82c4" : "#9e9e9e", marginBottom: "16px",
      }}>{title}</div>
    )}
    {children}
  </div>
);

const Toggle = ({ label, name, formik }) => {
  const checked = formik.values[name];
  return (
    <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer", userSelect: "none" }}>
      <span style={{
        position: "relative", display: "inline-block", width: "36px", height: "20px", flexShrink: 0,
      }}>
        <input type="checkbox" name={name} checked={checked}
          onChange={(e) => { formik.handleChange(e); formik.setFieldValue(name, e.target.checked); }}
          style={{ opacity: 0, width: 0, height: 0 }} />
        <span style={{
          position: "absolute", inset: 0, borderRadius: "20px",
          background: checked ? "#1a73e8" : "#e0e0e0", transition: "background 0.2s",
        }} />
        <span style={{
          position: "absolute", top: "2px", left: checked ? "18px" : "2px",
          width: "16px", height: "16px", borderRadius: "50%",
          background: "#fff", transition: "left 0.2s", boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
        }} />
      </span>
      <span style={{ fontSize: "0.88rem", fontWeight: 600, color: "#424242" }}>{label}</span>
    </label>
  );
};

const inputStyle = {
  width: "100%", padding: "8px 12px", border: "1px solid #e0e0e0",
  borderRadius: "8px", fontSize: "0.92rem", color: "#212121",
  background: "#fff", outline: "none", boxSizing: "border-box",
};

const Edit = ({ type, direction, titleText }) => {
  const [showRowEdit, setShowRowEdit] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [contact, setContact] = useState();
  const [positionen, setPositionen] = useState();
  const [editPosition, setEditPosition] = useState();
  const [showRowError, setShowRowError] = useState(false);
  const [showPosition, setShowPosition] = useState(false);
  const [extendedView, setExtendedView] = useState(false);
  let { id } = useParams();
  const [bill, setBill] = useState();
  const [address, setAddress] = useState();
  const [openDebitDate, setOpenDebitDate] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [paymentDeadline, setPaymentDeadline] = useState(new Date());
  const [showBill, setShowBill] = useState(false);
  const [reloadConnectedFileView, setReloadConnectedFileView] = useState(0);
  const [filePreview, setFilePreview] = useState(null);
  const [showLinker, setShowLinker] = useState(false);
  const [showPayModal, setShowPayModal] = useState(false);
  const [settings, setSettings] = useState();

  const editOutgoingBillForm = FinanceForm.createFinanceForm(type, direction);
  const formik = useFormik(editOutgoingBillForm);
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async (id) => {
      if (typeof id !== "undefined") {
        const bill = await billingApi.showBill(type, direction, id);
        setBill(bill);
        setPositionen(bill.positionen);
        setAddress(bill.fixed_address);
        formik.setValues(FinanceForm.setEditData(bill));
        setPaymentDeadline(Finance.calculatePaymentDeadline(bill.datum, bill.payment_due_days));
        setIsLoaded(true);
      }
    };
    loadData(id);
    setSettings(getSettings());
  }, [id]);

  const deleteFinance = async () => {
    const response = await FinanceApi.del(bill.id);
    if (response.status === 200) navigate("/finance/" + direction + "/" + type);
    else alert("Error while deleting");
  };

  useEffect(() => {
    if (!positionen) return;
    let netto = 0, brutto = 0;
    positionen.forEach((p) => {
      netto  += parseFloat(PositionDomain.calculatePositionNett(p));
      brutto += parseFloat(PositionDomain.calculatePositionGross(p));
    });
    formik.setFieldValue("netto", Math.round(netto * 100) / 100);
    formik.setFieldValue("brutto", Math.round(brutto * 100) / 100);
  }, [positionen]);

  const deleteFromList = async (index, apiCall) => {
    listHandler.deleteFromList(index, apiCall, setPositionen, positionen, setShowRowError);
  };

  const Buttons = () => (
    <div style={{ display: "inline-flex", gap: "8px", alignItems: "center" }}>
      <DocumentConnectionButtons showUpload={setShowNew} showLink={setShowLinker} />
      <button
        onClick={() => setShowBill(true)}
        style={{
          display: "inline-flex", alignItems: "center", gap: "6px",
          padding: "7px 12px", background: "#e8f0fe", color: "#1a73e8",
          border: "none", borderRadius: "8px", fontWeight: 600,
          fontSize: "0.82rem", cursor: "pointer",
        }}
      >
        <FontAwesomeIcon icon={faEye} /> Preview
      </button>
      <button
        onClick={() => setExtendedView((v) => !v)}
        style={{
          display: "inline-flex", alignItems: "center", gap: "6px",
          padding: "7px 12px",
          background: extendedView ? "#e8f0fe" : "#f5f5f5",
          color: extendedView ? "#1a73e8" : "#616161",
          border: `1px solid ${extendedView ? "#c5d9f8" : "#e0e0e0"}`,
          borderRadius: "8px", fontWeight: 600, fontSize: "0.82rem", cursor: "pointer",
          transition: "all 0.15s",
        }}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          {extendedView
            ? <><path d="M17 11l-5-5-5 5"/><path d="M17 18l-5-5-5 5"/></>
            : <><path d="M7 13l5 5 5-5"/><path d="M7 6l5 5 5-5"/></>
          }
        </svg>
        {extendedView ? "Simple view" : "Extended view"}
      </button>
      <IndexButtons
        setShow={setShowBill} viewBill={() => setShowBill(true)}
        bill={bill} direction={direction} type={type}
        deleteFunction={deleteFinance}
      />
    </div>
  );

  const Title = () => titleText;

  return !isLoaded ? null : (
    <>
      {settings && <PaymentModal show={showPayModal} setShow={setShowPayModal} priceTableId={settings.pricingTables.document} />}
      <DocumentLinker
        show={showLinker}
        setShow={setShowLinker}
        linkUrl={"/document/finance/" + id}
        onLinked={() => setReloadConnectedFileView(Math.random())}
      />
      <BillView show={showBill} bill={bill} setShow={setShowBill}>
        <BillOut bill={bill} />
      </BillView>
      <PositionModal show={showRowEdit} setShow={setShowRowEdit} financeId={id}
        position={editPosition} dataList={positionen} setDataFunction={setPositionen}
        showErrorFunction={setShowRowError} />
      <NewModal show={showNew} setShow={setShowNew}>
        <FileDropzone
          uploadUrl={"/document/finance/" + bill.id}
          setData={() => setReloadConnectedFileView(Math.random())}
          setShowPayModal={setShowPayModal}
        />
      </NewModal>
      <PositionView show={showPosition} setShow={setShowPosition} position={editPosition} />

      <FinanceHeader />
      <Content Title={Title} AdditionalButtons={Buttons}>

        {/* Header: address (left) + dates (right) */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px" }}>
          <Section title="Customer">
            <BillingHeaderLeft bill={bill} contact={contact} setContact={setContact}
              setAddress={setAddress} addressJson={address} formik={formik} />
          </Section>
          <Section title="Dates & Settings">
            <BillingHeaderRight formik={formik} extendedView={extendedView} />
          </Section>
        </div>

        {/* Status toggles — hidden in simple view */}
        {extendedView && (
          <Section title="Status" extended>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>
              <Toggle label="Draft" name="draft" formik={formik} />
              <Toggle label="Paid" name="geldeingang" formik={formik} />
              <Toggle label="Will be debited" name="autopay" formik={formik}
                onChange={(e) => { formik.handleChange(e); setOpenDebitDate(!openDebitDate); }} />
              <Toggle label="Private" name="privat" formik={formik} />
            </div>
            {openDebitDate && (
              <div style={{ marginTop: "14px", maxWidth: "240px" }}>
                <label style={{ fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9e9e9e", marginBottom: "6px", display: "block" }}>
                  Debit At
                </label>
                <input type="date" name="debitedat" onChange={formik.handleChange} style={inputStyle} />
              </div>
            )}
          </Section>
        )}

        {/* Subject + Description */}
        <Section title="Content">
          <div style={{ marginBottom: "14px" }}>
            <label style={{ fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9e9e9e", marginBottom: "6px", display: "block" }}>Subject</label>
            <input type="text" name="betreff" placeholder="Subject" value={formik.values.betreff}
              onChange={formik.handleChange} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9e9e9e", marginBottom: "6px", display: "block" }}>Description</label>
            <textarea name="beschreibung" placeholder="Description" value={formik.values.beschreibung}
              onChange={formik.handleChange} rows={3}
              style={{ ...inputStyle, resize: "vertical", fontFamily: "inherit" }} />
          </div>
        </Section>

        {/* Positions */}
        <Section title="Positions">
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <PositionRowHeader />
              <tbody>
                {positionen?.map((position, index) => (
                  <PositionRow key={index} index={index} position={position}
                    setShowRowEdit={(p) => { setEditPosition(p); setShowRowEdit(true); }}
                    deleteFunction={deleteFromList}
                    setShowPosition={(p) => { setEditPosition(p); setShowPosition(true); }}
                  />
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "12px" }}>
            <button
              onClick={() => { setEditPosition(null); setShowRowEdit(true); }}
              style={{
                display: "inline-flex", alignItems: "center", gap: "6px",
                padding: "7px 14px", background: "#e8f5e9", color: "#2e7d32",
                border: "none", borderRadius: "8px", fontWeight: 600,
                fontSize: "0.85rem", cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faAdd} /> Add Position
            </button>
          </div>
        </Section>

        {/* Additional Notes (left, extended only) + Summary (right, always 50%) */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px" }}>
          {extendedView && (
            <Section title="Additional Notes" extended>
              <textarea name="post_text" placeholder="Additional text after the bill…"
                value={formik.values.post_text} onChange={formik.handleChange} rows={4}
                style={{ ...inputStyle, resize: "vertical", fontFamily: "inherit", background: "#f4f7ff" }} />
            </Section>
          )}
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gridColumn: extendedView ? "auto" : "2" }}>
            <BillSummary positionen={positionen} />
          </div>
        </div>

        {/* Payment terms */}
        <Section title="Payment Terms">
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9e9e9e", marginBottom: "6px", display: "block" }}>
                Payable Within (Days)
              </label>
              <input
                type="number" name="payment_due_days" placeholder="15"
                value={formik.values.payment_due_days}
                onChange={(e) => {
                  const due = Finance.calculatePaymentDeadline(formik.values.datum, e.target.value);
                  const dueStr = due.toISOString().split("T")[0];
                  setPaymentDeadline(due);
                  formik.setFieldValue("payment_deadline", dueStr);
                  formik.setFieldValue("payment_due_days", e.target.value);
                  formik.setFieldValue("wiedervorlage_datum", dueStr);
                }}
                style={{ ...inputStyle, maxWidth: "160px" }}
              />
            </div>
            <div style={{
              padding: "10px 16px", background: "#e8f5e9", borderRadius: "8px",
              fontSize: "0.88rem", fontWeight: 700, color: "#2e7d32",
            }}>
              Due: {paymentDeadline.toISOString().split("T")[0]}
            </div>
          </div>
        </Section>

        {/* Submit */}
        <SubmitButtons formik={formik} bill={bill} />

        {/* Connected files */}
        <div style={{ marginTop: "16px" }}>
          <ConnectedFiles show={reloadConnectedFileView} entity={bill}
            endpointAll="/document/finance/" endpointUnlink="/document/finance/"
            onFileSelect={setFilePreview} selectedFileId={filePreview?.id} />
        </div>

        {filePreview && (
          <FilePreviewModal
            attachment={filePreview}
            onClose={() => setFilePreview(null)}
            onUnlink={(id) => { setReloadConnectedFileView(Math.random()); }}
            endpointUnlink="/document/finance/"
          />
        )}

      </Content>
    </>
  );
};

export default Edit;
